import { makeStyles } from "@mui/styles";
const colors = {
    error: "#FF6E6E",
    info: "#2F47B2",
    "info-gray": "#6F7073",
    warning: "#FBC02D",
};
export const useStyles = makeStyles(({ spacing }) => ({
    icon: ({ variant }) => ({
        color: colors[variant],
        margin: spacing(1),
    }),
}));
//# sourceMappingURL=ui_helper.css.js.map